import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ConfigService {
  config!: any;

  constructor(private http: HttpClient) { }

  load(): Promise<void> {
    return firstValueFrom(this.http.get<any>('/config'))
      .then(cfg => {

        Object.keys(cfg).forEach(key => {
          localStorage.setItem(key, cfg[key]);
        });

        // valeur navigateur
        localStorage.setItem(
          'Vista_HostName',
          window.location.host
        );
      });
  }
}

